import React, { FunctionComponent } from 'react';

import { useTranslation } from 'react-i18next';

import { TRANSLATION_NAMESPACE } from 'directory/listings/notification-modals/constants';
import { ProgressStatsProps } from 'directory/listings/notification-modals/types';
import 'directory/listings/notification-modals/components/UpdatingFlow/ProgressStats.scss';

export const ProgressStats: FunctionComponent<ProgressStatsProps> = ({
    totalProfiles,
    profilesUpdated,
    profilesWithErrors,
}) => {
    const { t } = useTranslation(TRANSLATION_NAMESPACE);

    const formatNumber = (num: number | undefined): string => {
        if (num === undefined || num === null || Number.isNaN(num)) {
            return '0';
        }
        return num.toLocaleString();
    };

    return (
        <div className="progress-stats">
            <div className="progress-stats__card progress-stats__card--total">
                <div className="progress-stats__label">{t('TOTAL_PROFILES')}</div>
                <div className="progress-stats__value progress-stats__value--total">{formatNumber(totalProfiles)}</div>
            </div>

            <div className="progress-stats__card progress-stats__card--updated">
                <div className="progress-stats__label">{t('PROFILES_UPDATED')}</div>
                <div className="progress-stats__value progress-stats__value--updated">
                    {formatNumber(profilesUpdated)}
                </div>
            </div>

            <div className="progress-stats__card progress-stats__card--errors">
                <div className="progress-stats__label">{t('PROFILES_WITH_ERRORS')}</div>
                <div className="progress-stats__value progress-stats__value--errors">
                    {formatNumber(profilesWithErrors)}
                </div>
            </div>
        </div>
    );
};
